import styled from "styled-components";
import { Link } from "react-router-dom";

import { StyledCountdownHolder } from "storefront/features/productGrid/components/Auction.styled";

export const SuggestionCard = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const SuggestionImageWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 160px;
  margin-bottom: 0.75rem;

  img {
    max-height: 160px;
    object-fit: contain;
  }
`;

export const SuggestionMetaRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  width: 100%;
`;

export const SuggestionTitleLink = styled(Link)`
  width: 100%;
  text-decoration: none;
  color: #000;
  display: block;

  &:hover,
  &:focus {
    text-decoration: none;
    color: #000;
  }
`;

export const SuggestionTitle = styled.h5`
  margin: 0;
  padding: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  font-size: 15px;
  line-height: 20px;
  height: 80px;
  letter-spacing: 1px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  word-break: break-word;
`;

export const SuggestionTimer = styled(StyledCountdownHolder)`
  margin: 0;
  font-size: 1.2rem;
  text-align: center;
`;

export const SuggestionBidButtonWrap = styled.div`
  margin-top: auto;
  width: 100%;
  display: flex;
  justify-content: center;
`;
